import { NavLink, NavLinkProps } from "react-router-dom";
import React, { ReactNode } from "react";

export interface InlineLinkProps extends NavLinkProps {
  children: ReactNode;
}

const InlineLink = ({ children, ...props }: InlineLinkProps) => {
  return (
    <NavLink className="font-bold underline text-aqua border-aqua" {...props}>
      {children}
    </NavLink>
  );
};

export default InlineLink;
